import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/page/Login'

Vue.use(Router)

function eVerify (to, from, next) {
  let flag = JSON.parse(localStorage.getItem('user_info')).flag
  if (!flag) {
    next({ name: 'login' })
  }
  next()
}

export default new Router({
  routes: [{
    path: '/',
    redirect: '/login'
  }, {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '后端管理平台'
    },
  },
    {
      path: '/user_wx',
      component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
      meta: {
        title: '自述文件'
      },
      children: [
        {
        path: '/user_wx',
        name: 'user_wx',
        component: () => import(/* webpackChunkName: "table" */ '../components/page/user_wx/UserWxPage.vue'),
        meta: {
          title: '用户授权管理'
        },
        beforeEnter (to, from, next) {
          let token = localStorage.getItem('userMessage')
          if (!token) {
            next({ name: 'login' })
          }
          next()
        }
      }, {
        path: '/fire_eye',
        name: 'fire_eye',
        component: () => import(/* webpackChunkName: "table" */ '../components/page/fire_eye/FireEyePage.vue'),
        meta: {
          title: '火眼金睛'
        },
        beforeEnter (to, from, next) {
          let token = localStorage.getItem('userMessage')
          if (!token) {
            next({ name: 'login' })
          }
          next()
        }
      }, {
        path: '/user',
        name: 'user',
        component: () => import(/* webpackChunkName: "table" */ '../components/page/user/UserPage.vue'),
        meta: {
          title: '用户管理'
        },
        beforeEnter (to, from, next) {
          let token = localStorage.getItem('userMessage')
          if (!token) {
            console.log('user========================================token:' + token)
            next({ name: 'login' })
          }
          next()
        }
      }, {
        path: '/authCode',
        name: 'authCode',
        component: () => import(/* webpackChunkName: "table" */ '../components/page/authCode/authCodePage.vue'),
        meta: {
          title: '授权码管理'
        },
        beforeEnter (to, from, next) {
          let token = localStorage.getItem('userMessage')
          if (!token) {
            next({ name: 'login' })
          }
          next()
        }
      }, {
        path: '/carousel',
        component: () => import(/* webpackChunkName: "table" */ '../components/page/guanggao/GuangGaoPage.vue'),
        // component: () => import(/* webpackChunkName: "table" */ '../components/page/Upload.vue'),
        meta: {
          title: '广告轮播管理'
        }
      }, {
        path: '/knowledge',
        component: () => import(/* webpackChunkName: "tabs" */ '../components/page/zhishi/ZhiShiPage.vue'),
        meta: {
          title: '知识库'
        }
      },{
        path: '/404',
        component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
        meta: {
          title: '404'
        }
      }, {
        path: '/403',
        component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
        meta: {
          title: '403'
        }
      }]
    }, {
      path: '*',
      redirect: '/404'
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js